import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const QUICK_TRIAL_TEMPLATES = [
  // Pop Culture Hot Takes (8)
  { emoji: '🎬', title: 'Netflix > Disney+ (no contest)', sideA: 'Netflix Wins', sideB: 'Disney+ Better' },
  { emoji: '📱', title: 'iPhone > Android (objectively)', sideA: 'iPhone Gang', sideB: 'Android Army' },
  { emoji: '🎵', title: 'Taylor Swift > Beyoncé', sideA: 'Swifties Rise', sideB: 'Beyhive 4Ever' },
  { emoji: '🎮', title: 'PlayStation > Xbox', sideA: 'PS Gang', sideB: 'Xbox Squad' },
  { emoji: '🎧', title: 'Spotify > Apple Music', sideA: 'Spotify Wins', sideB: 'Apple Better' },
  { emoji: '📺', title: 'Friends > The Office', sideA: 'Friends Forever', sideB: 'Office Superior' },
  { emoji: '🎤', title: 'Concerts > Festivals', sideA: 'Concert Gang', sideB: 'Festival Vibes' },
  { emoji: '🎨', title: 'Marvel > DC', sideA: 'Marvel Wins', sideB: 'DC Superior' },

  // Food Quick Hits (7)
  { emoji: '🥞', title: 'Pancakes > Waffles', sideA: 'Pancake Gang', sideB: 'Waffle Crew' },
  { emoji: '🍕', title: 'Pizza for breakfast is acceptable', sideA: 'Pizza AM OK', sideB: 'Breakfast Only' },
  { emoji: '🥛', title: 'Cereal: Milk first or cereal first?', sideA: 'Cereal First', sideB: 'Milk First' },
  { emoji: '🍟', title: 'Ketchup on fries > Mayo on fries', sideA: 'Ketchup Wins', sideB: 'Mayo Gang' },
  { emoji: '🌭', title: 'Hot dogs are sandwiches', sideA: 'It\'s Sandwich', sideB: 'NOT Sandwich' },
  { emoji: '🍪', title: 'Cookies > Brownies', sideA: 'Cookie Gang', sideB: 'Brownie Better' },
  { emoji: '🧀', title: 'American cheese is real cheese', sideA: 'It\'s Cheese', sideB: 'Plastic Fake' },

  // Random Viral Debates (5)
  { emoji: '🧻', title: 'Toilet paper: Over or Under?', sideA: 'Over Squad', sideB: 'Under Crew' },
  { emoji: '👗', title: 'The dress was blue & black (not gold)', sideA: 'Blue & Black', sideB: 'White & Gold' },
  { emoji: '🥤', title: 'Straw color affects drink taste', sideA: 'Color Matters', sideB: 'All Same' },
  { emoji: '🚿', title: 'Showering at night > Morning showers', sideA: 'Night Shower', sideB: 'Morning Fresh' },
  { emoji: '🧊', title: 'Ice in cereal makes it better', sideA: 'Ice = Better', sideB: 'Absolute Psycho' },
];

function QuickTrialSeeder({ authUser, onClose }) {
  const [seeding, setSeeding] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const [completed, setCompleted] = useState(false);
  const [error, setError] = useState(null);

  const seedAllTrials = async () => {
    setSeeding(true);
    setError(null);
    setProgress({ current: 0, total: QUICK_TRIAL_TEMPLATES.length });

    try {
      for (let i = 0; i < QUICK_TRIAL_TEMPLATES.length; i++) {
        const trial = QUICK_TRIAL_TEMPLATES[i];
        
        const trialData = {
          title: trial.title,
          side_a: trial.sideA,
          side_b: trial.sideB,
          image_emoji: trial.emoji,
          trial_type: 'quick',
          created_by: authUser.id,
          creator_id: authUser.id,
          views: 0,
          shares: 0,
          votes_a: 0,
          votes_b: 0,
          status: 'filling',
          jury_size: 6,
          time_limit_seconds: 120, // 2 minutes
          expires_at: new Date(Date.now() + 120 * 1000).toISOString(),
          created_at: new Date().toISOString(),
        };

        const { error: insertError } = await supabase
          .from('trials')
          .insert([trialData]);

        if (insertError) throw insertError;

        setProgress({ current: i + 1, total: QUICK_TRIAL_TEMPLATES.length });
        
        // Small delay to avoid rate limits
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      setCompleted(true);
      setSeeding(false);
    } catch (err) {
      console.error('Seeding error:', err);
      setError(err.message);
      setSeeding(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚡</div>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '900' }}>
            Quick Trial Seeder
          </h2>
          <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
            Seed 20 rapid-fire trials with 2min countdown
          </p>
        </div>

        {!completed && !seeding && (
          <>
            <div style={{
              background: '#fef3c7',
              border: '2px solid #f59e0b',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '20px'
            }}>
              <div style={{ fontSize: '14px', color: '#78350f', lineHeight: '1.6' }}>
                <strong>⏰ TIMING CRITICAL:</strong>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                  <li><strong>Seed 5-10 min BEFORE going live</strong></li>
                  <li>Trials expire in 2 minutes each</li>
                  <li>Creates urgency + immediate engagement</li>
                  <li>Users arrive to active, ticking-down trials</li>
                </ul>
              </div>
            </div>

            <div style={{
              background: '#f0f9ff',
              border: '2px solid #0ea5e9',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '20px'
            }}>
              <div style={{ fontSize: '14px', color: '#0c4a6e', lineHeight: '1.6' }}>
                <strong>📊 What gets created:</strong>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                  <li>20 quick trials (2min each)</li>
                  <li>8 Pop Culture, 7 Food, 5 Viral Debates</li>
                  <li>Fun, low-stakes topics for fast engagement</li>
                  <li>Pairs with 30 grand trials for lasting content</li>
                </ul>
              </div>
            </div>

            <button
              onClick={seedAllTrials}
              style={{
                width: '100%',
                padding: '16px',
                background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '900',
                cursor: 'pointer',
                marginBottom: '12px'
              }}
            >
              ⚡ Seed All 20 Quick Trials
            </button>

            <div style={{
              background: '#fee2e2',
              border: '2px solid #ef4444',
              borderRadius: '12px',
              padding: '12px',
              marginBottom: '12px'
            }}>
              <p style={{ margin: 0, fontSize: '12px', color: '#991b1b', textAlign: 'center' }}>
                <strong>⚠️ Only click when ready to launch!</strong>
              </p>
            </div>
          </>
        )}

        {seeding && (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '100%',
              height: '8px',
              background: '#e5e7eb',
              borderRadius: '4px',
              overflow: 'hidden',
              marginBottom: '16px'
            }}>
              <div style={{
                width: `${(progress.current / progress.total) * 100}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #f59e0b, #ef4444)',
                transition: 'width 0.3s ease'
              }} />
            </div>
            <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
              Creating trial {progress.current} of {progress.total}...
            </p>
          </div>
        )}

        {completed && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>⚡</div>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '900', color: '#f59e0b' }}>
              Live in 2 Minutes!
            </h3>
            <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#666' }}>
              20 quick trials created with countdown timers
            </p>
            <div style={{
              background: '#fef3c7',
              border: '2px solid #f59e0b',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '20px',
              textAlign: 'left'
            }}>
              <div style={{ fontSize: '13px', color: '#78350f', lineHeight: '1.6' }}>
                <strong>🚀 Launch Checklist:</strong>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                  <li><strong>NOW:</strong> Share link with first users</li>
                  <li>Users see 50 total trials (30 grand + 20 quick)</li>
                  <li>Quick trials create urgency to vote NOW</li>
                  <li>Grand trials provide lasting content pool</li>
                </ul>
              </div>
            </div>
            <button
              onClick={onClose}
              style={{
                width: '100%',
                padding: '16px',
                background: '#f59e0b',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '900',
                cursor: 'pointer'
              }}
            >
              Let's Go! 🚀
            </button>
          </div>
        )}

        {error && (
          <div style={{
            background: '#fee2e2',
            border: '2px solid #ef4444',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '20px'
          }}>
            <p style={{ margin: 0, fontSize: '14px', color: '#991b1b' }}>
              <strong>Error:</strong> {error}
            </p>
          </div>
        )}

        {!completed && (
          <button
            onClick={onClose}
            disabled={seeding}
            style={{
              width: '100%',
              padding: '12px',
              background: 'transparent',
              color: '#666',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              fontSize: '14px',
              fontWeight: '700',
              cursor: seeding ? 'not-allowed' : 'pointer',
              opacity: seeding ? 0.5 : 1
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}

export default QuickTrialSeeder;
